import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Content from "../../content/home";
import "./style.css";

export default function Services() {
    gsap.registerPlugin(ScrollTrigger);

    const [content] = useState({ ...Content });
    const { title, subHeader, services, images, copy, video } = content[0].services[0];

    const videoRef = useRef(null);
    const isMobile = window.innerWidth < 900; // <- one-time check only

    useEffect(() => {
        // Only once: set autoplay/controls based on screen size
        if (videoRef.current) {
            videoRef.current.controls = isMobile;
            videoRef.current.autoplay = !isMobile;
            if (!isMobile) {
                videoRef.current.play().catch(() => {});
            }
        }

        // GSAP animation only for large screens
        const w = window.innerWidth;
        const targetWidth = 10000;

        if (w >= targetWidth) {
            const tl = gsap.timeline({
                defaults: { duration: 1, ease: "none" }
            });

            tl.from(".second-image", {
                autoAlpha: 0,
                x: -300,
                scrollTrigger: {
                    trigger: ".second-figure",
                    start: "top bottom",
                    end: "center center",
                    scrub: true,
                    toggleActions: "play none none reverse",
                    invalidateOnRefresh: true
                }
            }).from(".second-caption", {
                autoAlpha: 0,
                y: 100,
                scrollTrigger: {
                    trigger: ".second-figure",
                    start: "top center+=100",
                    end: "bottom center",
                    scrub: true,
                    toggleActions: "play none none reverse",
                    invalidateOnRefresh: true
                }
            });
        }
    }, []);

    const listItems = services.map((item, index) => (
        <li key={index}>{item}</li>
    ));

    return (
        <section id="services" className="clearfix">
            <h2 className="servicesHeader">{title}</h2>

            <video
                ref={videoRef}
                muted
                loop
                className="second-figure"
                poster="img/video-poster.jpg"
            >
                <source src={video[0].src} type="video/mp4" />
            </video>

            <p className="servicesCopy">{copy}</p>
            <div className="servicesList">
                <h3>{subHeader}</h3>
                <ol>{listItems}</ol>
            </div>
        </section>
    );
}
